import React from "react";

interface Props {
  chapterId: number;
}

interface Lesson {
  id: number;
  title: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: null | string;
  chapterId: number;
}

const SeasonCard: React.FC<Props> = ({ chapterId }) => {
  const lessons: Lesson[] = [
    {
      id: 11,
      title: "قسمت۱: بیوگرافی من",
      description: "",
      createdAt: "18/10/2025 16:05:34.534369",
      updatedAt: "18/10/2025 16:05:34.534369",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 12,
      title: "قسمت۲: اولین گام برای شروع مداحی",
      description: "",
      createdAt: "20/10/2025 07:57:50.744754",
      updatedAt: "20/10/2025 07:57:50.744754",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 13,
      title: "قسمت۳: صداسازی چیست؟",
      description: "",
      createdAt: "20/10/2025 07:58:58.428527",
      updatedAt: "20/10/2025 07:58:58.428527",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 14,
      title: "قسمت۴: انواع متدهای صداسازی",
      description: "",
      createdAt: "20/10/2025 07:59:32.412442",
      updatedAt: "20/10/2025 07:59:32.412442",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 15,
      title: "قسمت۵: آشنایی کلی با متد سی وی تی",
      description: "",
      createdAt: "20/10/2025 08:00:07.508184",
      updatedAt: "20/10/2025 08:00:07.508184",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 16,
      title:
        "قسمت۶: آیا صداسازی در قرائت با صداسازی در مداحی یا آواز و ... متفاوته؟",
      description: "",
      createdAt: "20/10/2025 08:00:27.068443",
      updatedAt: "20/10/2025 08:00:27.068443",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 17,
      title: "قسمت۷: آیا خوانندگان بزرگ صداسازی انجام داده اند؟",
      description: "",
      createdAt: "20/10/2025 08:00:57.453574",
      updatedAt: "20/10/2025 08:00:57.453574",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 18,
      title: "قسمت۸: آیا میتوان همزمان در شاخه های گوناگون صدا فعالیت داشت؟",
      description: "",
      createdAt: "20/10/2025 08:01:34.838",
      updatedAt: "20/10/2025 08:01:34.838",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 19,
      title:
        "قسمت۹: من گوینده،مجری،سخنران هستم، آیا صداسازی برای من با صداسازی برای خواننده ها متفاوته؟تفاوت صدا و بیان؟",
      description: "",
      createdAt: "20/10/2025 08:02:05.798909",
      updatedAt: "20/10/2025 08:02:05.798909",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 20,
      title:
        "قسمت۱۰: صدای من بدرد(مثلا مداحی) نمیخورد، چکار کنم؟ صدای من به چه دردی میخورد؟",
      description: "",
      createdAt: "20/10/2025 08:02:32.449679",
      updatedAt: "20/10/2025 08:02:32.449679",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 21,
      title: "قسمت۱۱: من عجله دارم راه سریعتری نیست؟",
      description: "",
      createdAt: "20/10/2025 08:02:53.580187",
      updatedAt: "20/10/2025 08:02:53.580187",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 22,
      title: "قسمت۱۲: صدا تا چه سنی قابل رشد است؟ برای این کارها دیر نیست؟",
      description: "",
      createdAt: "20/10/2025 08:03:25.963694",
      updatedAt: "20/10/2025 08:03:25.963694",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 23,
      title:
        "قسمت۱۳: آیا در دوران بلوغ میتوان صداسازی کار کرد؟ از چه سنی باید شروع کرد؟",
      description: "",
      createdAt: "20/10/2025 08:03:48.195878",
      updatedAt: "20/10/2025 08:03:48.195878",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 24,
      title: "قسمت۱۴: صدا اکتسابی است یا وراثتی؟",
      description: "",
      createdAt: "20/10/2025 08:05:04.876465",
      updatedAt: "20/10/2025 08:05:04.876465",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 25,
      title: "قسمت۱۵: صدای من فلان مشکل را دارد، چه باید بکنم؟",
      description: "",
      createdAt: "20/10/2025 08:05:22.513892",
      updatedAt: "20/10/2025 08:05:22.513892",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 26,
      title: "قسمت۱۶: چه کسی را قبول دارید؟ نظرتان در مورد فلان خواننده چیست؟",
      description: "",
      createdAt: "20/10/2025 08:05:37.890064",
      updatedAt: "20/10/2025 08:05:37.890064",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 27,
      title: "قسمت۱۷: چطور میتوانم صدای خودم را خوشگل و جذاب کنم؟",
      description: "",
      createdAt: "20/10/2025 08:06:32.248997",
      updatedAt: "20/10/2025 08:06:32.248997",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 28,
      title: "قسمت ۱۸ : ویژگی صدا از دیدگاه انجمن بین‌المللی صدا",
      description: "",
      createdAt: "20/10/2025 08:06:56.397149",
      updatedAt: "20/10/2025 08:06:56.397149",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 29,
      title: "قسمت۱۹: اهمیت قوی بودن گوش موسیقایی برای خواندن؟ سلفژ چیست؟",
      description: "",
      createdAt: "20/10/2025 08:07:27.90095",
      updatedAt: "20/10/2025 08:07:27.90095",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 30,
      title:
        "قسمت ۲۰: من صدای خودم (یا صدای ضبط شده خودم) را دوست ندارم مشکل کجاست؟",
      description: "",
      createdAt: "20/10/2025 08:07:46.027833",
      updatedAt: "20/10/2025 08:07:46.027833",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 31,
      title: "قسمت ۲۱ تقلید کنیم؟ از چه کسی ؟ هدف از تقلید؟",
      description: "",
      createdAt: "20/10/2025 08:08:10.351457",
      updatedAt: "20/10/2025 08:08:10.351457",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 32,
      title: "قسمت۲۲: چقدر باید وقت بگذاریم؟ پرورش صدا و بیان چقدر طول میکشد؟",
      description: "",
      createdAt: "20/10/2025 08:09:05.596636",
      updatedAt: "20/10/2025 08:09:05.596636",
      deletedAt: null,
      chapterId: 6,
    },
    {
      id: 33,
      title: "قسمت۱ : آشنایی کلی با متد سی وی تی",
      description: "",
      createdAt: "20/10/2025 09:11:24.814735",
      updatedAt: "20/10/2025 09:11:24.814735",
      deletedAt: null,
      chapterId: 7,
    },
    {
      id: 34,
      title: "قسمت۲:ساپورت",
      description: "",
      createdAt: "20/10/2025 09:11:59.86112",
      updatedAt: "20/10/2025 09:11:59.86112",
      deletedAt: null,
      chapterId: 7,
    },
    {
      id: 35,
      title: "قسمت۳:توانگ",
      description: "",
      createdAt: "20/10/2025 09:14:07.975246",
      updatedAt: "20/10/2025 09:14:07.975246",
      deletedAt: null,
      chapterId: 7,
    },
    {
      id: 36,
      title: "قسمت۴:عدم انقباض فک و لب",
      description: "",
      createdAt: "20/10/2025 09:14:27.119278",
      updatedAt: "20/10/2025 09:14:27.119278",
      deletedAt: null,
      chapterId: 7,
    },
    {
      id: 37,
      title: "قسمت۵:آشنایی کلی با مودها",
      description: "",
      createdAt: "20/10/2025 09:14:47.799334",
      updatedAt: "20/10/2025 09:14:47.799334",
      deletedAt: null,
      chapterId: 7,
    },
    {
      id: 38,
      title: "قسمت۶: مودنیوترال",
      description: "",
      createdAt: "20/10/2025 09:15:56.326849",
      updatedAt: "20/10/2025 09:15:56.326849",
      deletedAt: null,
      chapterId: 7,
    },
    {
      id: 39,
      title: "قسمت۷:مود کربینگ",
      description: "",
      createdAt: "20/10/2025 09:16:10.584903",
      updatedAt: "20/10/2025 09:16:10.584903",
      deletedAt: null,
      chapterId: 7,
    },
    {
      id: 40,
      title: "قسمت۸:مود اوردرایو",
      description: "",
      createdAt: "20/10/2025 09:16:24.480482",
      updatedAt: "20/10/2025 09:16:24.480482",
      deletedAt: null,
      chapterId: 7,
    },
    {
      id: 41,
      title: "قسمت۹:مود ادج",
      description: "",
      createdAt: "20/10/2025 09:16:42.081176",
      updatedAt: "20/10/2025 09:16:42.081176",
      deletedAt: null,
      chapterId: 7,
    },
    {
      id: 42,
      title: "قسمت۱۰: انتقال بین مودها",
      description: "",
      createdAt: "20/10/2025 09:17:06.754677",
      updatedAt: "20/10/2025 09:17:06.754677",
      deletedAt: null,
      chapterId: 7,
    },
    {
      id: 43,
      title: "قسمت۱۱: رنگ صدا",
      description: "",
      createdAt: "20/10/2025 09:17:37.762889",
      updatedAt: "20/10/2025 09:17:37.762889",
      deletedAt: null,
      chapterId: 7,
    },
    {
      id: 44,
      title: "قسمت۱۲: افکت",
      description: "",
      createdAt: "20/10/2025 09:18:04.26372",
      updatedAt: "20/10/2025 09:18:04.26372",
      deletedAt: null,
      chapterId: 7,
    },
    {
      id: 45,
      title: "قسمت ۱۳: آشنایی با کتاب",
      description: "",
      createdAt: "20/10/2025 09:18:19.748154",
      updatedAt: "20/10/2025 09:18:19.748154",
      deletedAt: null,
      chapterId: 7,
    },
    {
      id: 46,
      title: "مقدمه: شرح کوتاه این فصل",
      description: "",
      createdAt: "20/10/2025 09:20:26.304957",
      updatedAt: "20/10/2025 09:20:26.304957",
      deletedAt: null,
      chapterId: 8,
    },
    {
      id: 47,
      title: "تمرین۱: تنفس دنده ای",
      description: "",
      createdAt: "20/10/2025 09:20:41.268262",
      updatedAt: "20/10/2025 09:20:41.268262",
      deletedAt: null,
      chapterId: 8,
    },
    {
      id: 48,
      title: "تمرین۲: پیس یک دقیقه ایی",
      description: "",
      createdAt: "20/10/2025 09:21:00.674669",
      updatedAt: "20/10/2025 09:21:00.674669",
      deletedAt: null,
      chapterId: 8,
    },
    {
      id: 49,
      title: "تمرین۳: توانگ",
      description: "",
      createdAt: "20/10/2025 09:21:20.717275",
      updatedAt: "20/10/2025 09:21:20.717275",
      deletedAt: null,
      chapterId: 8,
    },
    {
      id: 50,
      title: "تمرین۴: رفع انقباض فک",
      description: "",
      createdAt: "20/10/2025 09:21:38.16895",
      updatedAt: "20/10/2025 09:21:38.16895",
      deletedAt: null,
      chapterId: 8,
    },
    {
      id: 51,
      title: "تمرین۵: رفع انقباض لب ها",
      description: "",
      createdAt: "20/10/2025 09:22:13.761852",
      updatedAt: "20/10/2025 09:22:13.761852",
      deletedAt: null,
      chapterId: 8,
    },
    {
      id: 52,
      title: "تمرین۶: رفع انقباض زبان",
      description: "",
      createdAt: "20/10/2025 09:22:31.816407",
      updatedAt: "20/10/2025 09:22:31.816407",
      deletedAt: null,
      chapterId: 8,
    },
    {
      id: 53,
      title: "تمرین۷: صدای دارک و بزرگ",
      description: "",
      createdAt: "20/10/2025 09:22:49.816403",
      updatedAt: "20/10/2025 09:22:49.816403",
      deletedAt: null,
      chapterId: 8,
    },
  ];

  const chapterLessons = lessons.filter((l) => l.chapterId === chapterId);

  return (
    <div className="bg-white/25 w-full h-[316px] md:h-[438px] rounded-[37px] flex flex-col justify-start py-6 px-3 relative">
      <div
        className="overflow-y-auto max-h-full pr-3 scrollbar-thin scrollbar-thumb-white/80 scrollbar-track-transparent"
        style={{ direction: "ltr" }}
      >
        {chapterLessons.map((lesson, index) => (
          <p
            key={lesson.id}
            className={`font-kalameh text-white px-5 py-2 rounded-[38px] ${
              index === 1 ? "" : ""
            }`}
            style={{ direction: "rtl" }}
          >
            {lesson.title}
          </p>
        ))}
      </div>
      <style>
        {`
      .scrollbar-thin::-webkit-scrollbar {
        width: 12px;
      }
      .scrollbar-thin::-webkit-scrollbar-track {
        background: transparent;
      }
      .scrollbar-thin::-webkit-scrollbar-thumb {
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 9999px;
      }
    `}
      </style>
    </div>
  );
};

export default SeasonCard;
